import { createSelector } from 'reselect';
import { IApplicationState, TCardId } from '../../../../../../types/types';
import { IComment } from '../../../../../../store/model/card/types/IComment';
import { getCardComments } from '../../../../../../store/model/selectors/getCardComments';
import { EUserSettingsCommentSort } from '../../../../../../types/rest/IRestAuthUser';
import {
    getAuthUserSettingsCommentsSort
} from '../../../../../../store/model/authUser/selectors/getAuthUserSettingsCommentsSort';
import { getIsChatViewActive } from '../../../../../../store/router/selectors/getIsChatViewActive';

type TgetSortedComments = (
    state: IApplicationState,
    cardId: TCardId,
) => IComment[];

type TsortFunction = (
    a: IComment,
    b: IComment,
) => number;

const getCommentSortFunction = (
    userSettingsCommentSort: EUserSettingsCommentSort
): TsortFunction => {
    return (a, b) => {
        const compareResult = b.created - a.created;
        return userSettingsCommentSort * compareResult;
    };
};

const getSortedCommentsSelector = (
    userSettingsCommentSort: EUserSettingsCommentSort,
    isChatView: boolean,
    comments: IComment[],
) => {
    return [...comments].sort(getCommentSortFunction(!isChatView && userSettingsCommentSort));
};

export const getSortedCommentsCreateSelector = (
): TgetSortedComments => createSelector([
        getAuthUserSettingsCommentsSort,
        getIsChatViewActive,
        getCardComments,
    ],
    getSortedCommentsSelector,
);

export const getSortedComments: TgetSortedComments = getSortedCommentsCreateSelector();
